const COPY = {
  tr: {
    title: "Bir şeyler ters gitti",
    message: "Beklenmeyen bir hata oluştu. Lütfen tekrar dene.",
    retry: "Tekrar Dene",
  },
  en: {
    title: "Something went wrong",
    message: "An unexpected error occurred. Please try again.",
    retry: "Try Again",
  },
} as const;

// Error boundaries render outside the dictionary's reach: they get no `lang`
// param and can't await getDictionary, so the locale is read off the URL.
export function errorCopy(pathname?: string) {
  const p =
    pathname ?? (typeof window === "undefined" ? "" : window.location.pathname);
  return p.startsWith("/en") ? COPY.en : COPY.tr;
}
